import { useRouter, usePathname } from "@/lib/router-helpers"
import { type Locale, locales, localeNames } from "@/i18n/config"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { ChevronDown } from "lucide-react"
import { useTranslation } from "react-i18next";


export function LanguageSwitcher() {
 
  const { t, i18n } = useTranslation();


  const handleLanguageChange = (newLocale: Locale) => {
    localStorage.setItem("language", newLocale);
   i18n.changeLanguage(newLocale);
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-gray-50 text-gray-600 text-xs font-bold hover:bg-pink-50 hover:text-pink-600 transition-all duration-200 outline-none ring-offset-2 focus:ring-2 focus:ring-pink-100">
        <span className="uppercase tracking-wide">{i18n.language === 'en' ? 'En' : i18n.language === 'am' ? 'አማ' : i18n.language === 'oro' ? 'Oro' : 'Tig'}</span>
        <ChevronDown className="w-3.5 h-3.5 opacity-50" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-32 p-1 rounded-xl shadow-lg border-gray-100 animate-in zoom-in-95 duration-200">
        {locales.map((locale) => (
          <DropdownMenuItem
            key={locale}
            onClick={() => handleLanguageChange(locale)}
            className={`
              rounded-lg text-xs font-bold cursor-pointer transition-colors px-3 py-2
              ${i18n.language === locale 
                ? "bg-pink-50 text-pink-700" 
                : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              }
            `}
          >
            {localeNames[locale]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
